import React, { useEffect, useState } from 'react'
import axios from 'axios';

export default function Syarat() {
  const [tampil, setTampil] = useState(false);
  const [carapertama, setCarapertama] = useState(false);
  const [carakedua, setCarakedua] = useState(false);
  const [voucher, setVoucher] = useState([])
  const urlapi = process.env.REACT_APP_BASE_URL;

  const handlesyarat = (val) => {
    if (val == 'tampil') {
      setTampil(true);
    } else {
      setTampil(false)
    }
  }

  const handlevoucher = (list) => {
    if (list == 'pertama') {
      setCarapertama(true);
      setCarakedua(false);
    } else if (list == 'kedua') {
      setCarakedua(true)
      setCarapertama(false);
    }
  }

  const getdata = async () => {
    try {
      const response = await axios.get(urlapi + 'Voucher?iduser=' + localStorage.getItem('id'))
      setVoucher(response.data)
    } catch (error) {
      // console.log(error.message);

    }
  }

  useEffect(() => {
    getdata();
  }, [])

  return (
    <div>

      <div className='card mb-3 shadow border-0'>
        <div className='card-body text-secondary'>
          <div class="d-flex justify-content-between">
            <label className='fw-bold mb-3'>Syarat dan ketentuan</label>
            <label className='fw-bold'><i className='fas fa-gear'></i></label>
          </div>
          Untuk mendapatkan voucher gratis booking lapangna medan mini soccer anda harus memenuhi syarat dan ketentuan sebagai berikut :

          {tampil == true ? <><ul>
            <li>Mempunyai akun medan mini soccer (Tidak menggunakan mode tamu) </li>
            <li>Mempunyai 20 Jam booking lapangan mulai dari bulan Oktober 2024 </li>
            <li>Berlaku mulai dari bulan Oktober 2024</li>
            <li>Status booking lapangan harus disetujui</li>
            <li>Penggunaan voucher untuk booking lapangan hanya berlaku pada hari Senin, Selasa, Sabtu atau Minggu</li>
            <li>Total pembayaran kurang dari 10 Juta Free Lapangan Blue Dragon </li>
            <li>Total pembayaran 10 Juta s/d kurang dari 13 Juta Free Lapangan Red Tiger</li>
            <li>Total pembayaran sama dengan 13 Juta atau lebih dari 13 Juta Free Lapangan White Rat </li>
          </ul>
            <div className='text-primary' onClick={() => handlesyarat('tutup')} style={{ cursor: 'pointer' }}>Tutup syarat dan ketentuan ?</div>
          </> : <><div className='text-primary' onClick={() => handlesyarat('tampil')} style={{ cursor: 'pointer' }}>Lihat lebih banyak ?</div></>}

        </div>
      </div>

      <div className={voucher == '' ? 'card shadow border-0 d-none' : 'card shadow border-0'}>
        <div className='card-body text-secondary'>
          <div class="d-flex justify-content-between">
            <label className='fw-bold mb-3'>Cara menggunakan voucher</label>
            <label className='fw-bold'><i className='fas fa-ticket'></i></label>
          </div>
          <div>
            <div className='row mt-1'>
              <div className='col-sm-6 col-6'>
                <div className={carapertama == true ? 'card border-primary text-primary' : 'card'} onClick={() => handlevoucher('pertama')}>
                  <div className='card-body fw-bold' style={{ color: '#2b2e5a' }}>
                    <small style={{ fontSize: '12px' }}> <i className='fas fa-gear'></i> Cara pertama</small>
                  </div>
                </div>
              </div>
              <div className='col-sm-6 col-6'>
                <div className={carakedua == true ? 'card border-primary text-primary' : 'card'} onClick={() => handlevoucher('kedua')}>
                  <div className='card-body fw-bold' style={{ color: '#2b2e5a' }}>
                    <small style={{ fontSize: '12px' }}> <i className='fas fa-gear'></i> Cara kedua</small>
                  </div>
                </div>
              </div>
            </div>

            <div className={carapertama == true ? '' : 'd-none'}>
              <div className='mt-3 mb-2 fw-bold' style={{ fontSize: '12px' }}>Cara pertama</div>
              <ul style={{ fontSize: '12px' }}>
                <li>Pastikan akun anda mendapatkan voucher gratis booking lapangan</li>
                <li>Klik tombol <span className='text-primary fw-bold'> "Gunakan Voucher" </span> </li>
                <li>Pilih tanggal main <span className='text-primary fw-bold'>(Senin, Selesa, Sabtu atau Minggu) </span> dan jam main anda sesuai jenis lapangan yang ada di voucher anda</li>
                <li>Waktu main wajib di pilih sebanyak 2 jam sesuai waktu voucher yang anda dapat</li>
                <li>Setelah tanggal dan waktu sudah ditentukan selanjutnya klik tombol <span className='text-primary fw-bold'>"Booking lapangan"</span></li>
                <li>Setelah itu tunggu status cleim voucher anda, jika status <span className='text-success fw-bold'> "Disetujui" </span> maka anda berhasil booking lapangan mengunakan voucher anda</li>
                <li>Dan jika status <span className='text-danger fw-bold'> "Ditolak"</span> maka pilih tanggal dan waktu yang lain untuk menggunakan voucher anda </li>
              </ul>
              <div className='text-primary' style={{ fontSize: '12px', cursor: 'pointer' }} onClick={() => setCarapertama(false)}>Tutup halaman</div>
            </div>

            <div className={carakedua == true ? '' : 'd-none'}>
              <div className='mt-3 mb-2 fw-bold' style={{ fontSize: '12px' }}>Cara kedua</div>
              <ul style={{ fontSize: '12px' }}>
                <li>Pastikan akun anda mendapatkan voucher gratis booking lapangan</li>
                <li>Klik tombol <span className='text-primary fw-bold'>"Unduh Voucher" </span></li>
                <li>Setelah kamu mengunduh voucher  kirim voucher yang telah di unduh ke nomor whatsapp admin <span className='text-success fw-bold'>(+62 822-6765-4800) </span></li>
                <li>Kirim jadwal main anda <span className='text-primary fw-bold'> (Senin atau Selasa)</span> seperti tanggal dan jam bermain anda</li>
                <li>Setealah itu tunggu konfirmasi dari admin medan mini soccer</li>
              </ul>
              <div className='text-primary' style={{ fontSize: '12px', cursor: 'pointer' }} onClick={() => setCarakedua(false)}>Tutup halaman</div>
            </div>



          </div>
        </div>
      </div>
      <hr />
    </div >
  )
}
